import { STRIPE } from "../constants";

const { PUBLISHABLE_KEY } = STRIPE;

const loadStripeCard = (form_id, formHandler) => {
  if (document.getElementById("card-element") === null) return;
  const stripe = Stripe(PUBLISHABLE_KEY);
  const elements = stripe.elements();
  // Create an instance of the card Element.
  const card = elements.create("card", {
    style: { base: { color: "#FAFAFA" } },
  });
  // Add an instance of the card Element into the `card-element` <div>.
  card.mount("#card-element");

  // Handle real-time validation errors from the card Element.
  card.addEventListener("change", function (event) {
    const displayError = document.getElementById("card-errors");
    if (event.error) {
      displayError.textContent = event.error.message;
    } else {
      displayError.textContent = "";
    }
  });

  handlerFormSubmussion(stripe, card, form_id, formHandler);
};

const handlerFormSubmussion = (stripe, card, form_id, formHandler) => {
  const form = document.getElementById(form_id);

  form.addEventListener("submit", async function (event) {
    event.preventDefault();
    const result = await stripe.createToken(card, null);
    if (result.error) {
      // Inform the user if there was an error.
      const errorElement = document.getElementById("card-errors");
      errorElement.textContent = result.error.message;
    } else {
      // Send the response.
      formHandler(result);
    }
  });
};

function getSourceValues() {
  const getFormValue = (name) => document.getElementsByName(name)[0].value;

  return {
    address_line1: getFormValue("source[address_line1]"),
    address_line2: getFormValue("source[address_line2]"),
    address_city: getFormValue("source[address_city]"),
    address_zip: getFormValue("source[address_zip]"),
    address_state: getFormValue("source[address_state]"),
    address_country: getFormValue("source[address_country]"),
  };
}

export { getSourceValues };
export { loadStripeCard as default };
